import { request } from './apiClient'

export function fetchSyncPreview(mappingIds = null) {
  const body = mappingIds ? { mapping_ids: mappingIds } : {}
  return request("POST", "/v1/sync/preview", body)
}

export function runSync(mappingIds = null) {
  const body = mappingIds ? { mapping_ids: mappingIds } : {}
  return request("POST", "/v1/sync/run", body)
}

export function fetchSyncStatus(taskId) {
  return request("GET", `/v1/sync/status/${taskId}/`)
}
